'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ceil2 = require('lodash/ceil');

var _ceil3 = _interopRequireDefault(_ceil2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

var _flatten2 = require('lodash/flatten');

var _flatten3 = _interopRequireDefault(_flatten2);

var _lt2 = require('lodash/lt');

var _lt3 = _interopRequireDefault(_lt2);

var _gt2 = require('lodash/gt');

var _gt3 = _interopRequireDefault(_gt2);

var _every2 = require('lodash/every');

var _every3 = _interopRequireDefault(_every2);

var _isNull2 = require('lodash/isNull');

var _isNull3 = _interopRequireDefault(_isNull2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

exports.computePivot = computePivot;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _constants = require('../utils/constants');

var _computors = require('../utils/computors');

var utilsComputors = _interopRequireWildcard(_computors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computePivot(options, data, datumAccessor) {
  var pivot = options.linear.pivot.value;
  if (!(0, _isNull3.default)(pivot)) return pivot;
  var extent = _d2.default.extent(data, datumAccessor);
  if ((0, _every3.default)(extent, function (e) {
    return (0, _gt3.default)(e, 0);
  })) return (0, _ceil3.default)((0, _head3.default)(extent));else if ((0, _every3.default)(extent, function (e) {
    return (0, _lt3.default)(e, 0);
  })) return (0, _ceil3.default)((0, _last3.default)(extent));
  return 0;
}

function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    xRange: function xRange(options) {
      return [0, options.base.width];
    },
    yRange: function yRange(options) {
      return [options.base.height, 0];
    },
    xDomain: function xDomain(options, data) {
      return utilsComputors.computeLinearDomain(options.axis.x, target.computors.data(data), target.accessors.x);
    },
    yDomain: function yDomain(options, data) {
      return utilsComputors.computeLinearDomain(options.axis.y, target.computors.data(data), target.accessors.y);
    },
    xScale: function xScale(options, data) {
      return utilsComputors.computeLinearScale(target.computors.xRange(options), target.computors.xDomain(options, data));
    },
    yScale: function yScale(options, data) {
      return utilsComputors.computeLinearScale(target.computors.yRange(options), target.computors.yDomain(options, data));
    },
    data: function data(_data) {
      return (0, _flatten3.default)((0, _map3.default)(_data, function (serie) {
        return (0, _get3.default)(serie, 'datapoints', []);
      }));
    },
    annotationData: function annotationData(display, datum) {
      switch (display) {
        case _constants.NEVER:
          return [];
        case _constants.HIGHLIGHT:
          return target.accessors.isHighlighted(datum) ? [datum] : [];
        case _constants.BASELINE:
          return target.accessors.isABaseline(datum) ? [datum] : [];
        case _constants.FOCUS:
          return target.accessors.isFocused(datum) ? [datum] : [];
        case _constants.ALWAYS:default:
          return [datum];
      }
    },
    xPivot: function xPivot(options, data) {
      return computePivot(options.axis.x, target.computors.data(data), target.accessors.x);
    },
    yPivot: function yPivot(options, data) {
      return computePivot(options.axis.y, target.computors.data(data), target.accessors.y);
    }
  });
}
exports.default = computors;